export const network = {
    accessLog: 'Netzwerk-Zugriffsprotokoll',
    viewAccessLog: 'Zugriffsprotokoll ansehen',
    accessLogHint: 'Erfolgreiche Profilaufrufe, neueste zuerst. Eigene Aufrufe und Suchergebnisse werden nicht erfasst.',
    loadingViews: 'Profilaufrufe werden geladen…',
    noProfileViews: 'Noch keine Profilaufrufe',
    noProfileViewsHint: 'Hier erscheinen Besuche, sobald andere Netzwerkteilnehmer dieses Profil öffnen.',
    loadViewsError: 'Die Profilaufrufe konnten nicht geladen werden.',
    newestViews: 'Neueste Aufrufe',
    olderViews: 'Ältere Aufrufe',
    title: 'Netzwerk',
    viewNetwork: 'Netzwerk ansehen',
    description: 'Finde Menschen in Deinen Organisationen und vernetze Dich.',
    participationRequired: 'Tritt dem Netzwerk dieser Organisation bei, um andere Profile zu sehen. Öffne Dein Profil, um Deine geteilten Angaben zu prüfen und der Teilnahme zuzustimmen.',
    chooseOrganization: 'Organisation auswählen',
    search: 'Namen und geteilte Profilinformationen suchen',
    filters: 'Filter',
    empty: 'Keine passenden Profile',
    emptyMessage: 'Versuche eine andere Suche oder ändere Deine Filter.',
    unavailable: 'Dieses Netzwerk ist nicht verfügbar',
    unavailableMessage: 'Das Netzwerk wurde möglicherweise deaktiviert oder Dein Zugang hat sich geändert.',
    noValue: 'Nicht angegeben',
    yes: 'Ja',
    no: 'Nein',
    retry: 'Erneut versuchen',
    all: 'Alle',
    profileViewsPage: {
        refresh: 'Aktualisieren',
        title: 'Profilaufrufe',
        action: 'Wer hat mein Profil angesehen?',
    },
    join: {
        title: 'Dem Netzwerk beitreten',
        action: 'Netzwerk beitreten',
        description: 'Prüfe Dein Profil oben und wähle aus, welche optionalen Angaben Du mit anderen Teilnehmenden teilen möchtest.',
        sharedFields: 'Dein Name wird immer geteilt. Weitere erforderliche Angaben: {{fields}}.',
        nameOnly: 'keine',
        optionalFields: 'Optional geteilte Angaben',
        reciprocalHint: 'Du kannst optionale Angaben nur sehen, wenn Du sie auch selbst teilst.',
        consentTitle: 'Einwilligung zur Teilnahme',
        privacy: 'Datenschutzhinweise lesen',
        privacyError: 'Die Datenschutzhinweise konnten nicht geöffnet werden.',
        withdrawal: 'Du kannst Deine Einwilligung widerrufen, indem Du in den Details Deines verknüpften Kontakts das Netzwerk verlässt.',
        managedWithdrawal: 'Kontaktiere Deine Organisation, um Deine Einwilligung zu widerrufen und das Netzwerk zu verlassen.',
        accept: 'Ich stimme der Teilnahme zu',
        saved: 'Du bist dem Netzwerk beigetreten.',
    },
    profilePage: {
        manageMyProfile: 'Mein Profil verwalten',
        saved: 'Gespeichert',
        title: 'Profil',
        profileDetails: 'Profilinformationen',
        contactDetails: 'Kontaktdaten',
        reviewed: 'Zuletzt bestätigt',
        reviewPrompt: 'Bitte prüfe Dein Profil und bestätige, dass Deine Angaben aktuell sind.',
        confirmReview: 'Profil als aktuell bestätigen',
        preview: 'Noch nicht geteilt. Nur Du siehst diese Vorschau, bis Du dem Netzwerk beitrittst.',
        editContact: 'Kontaktdaten bearbeiten',
        visibleFields: 'Sichtbare Eigenschaften auswählen',
        leave: {
            action: 'Netzwerk verlassen',
            description: 'Dein Profil wird im Netzwerk ausgeblendet. Du kannst erneut teilnehmen, indem Du der Teilnahme zustimmst.',
        },
    },
    customFields: 'Zusatzfelder',
    errors: {
        selfJoin: 'Deine Organisation erlaubt keinen selbstständigen Beitritt.',
        consentChanged: 'Die Teilnahmebedingungen haben sich geändert. Bitte prüfe die aktualisierten Informationen und versuche es erneut.',
        profileViewLimit: 'Du hast Dein Limit von {{limit}} Profilen pro 24 Stunden erreicht. Ab {{availableAt}} kannst Du ein weiteres Profil öffnen. Bereits angesehene Profile bleiben verfügbar.',
        viewInProgress: 'Ein anderes Profil wird gerade geöffnet. Bitte versuche es gleich noch einmal.',
        optOut: 'Deine Organisation verwaltet den Widerruf der Netzwerkeinwilligung. Bitte wende Dich an sie.',
        access: 'Du hast keinen Zugang zu diesem Netzwerk.',
        consent: 'Nimm am Netzwerk teil, bevor Du andere Profile ansiehst.',
        field: 'Dieses Feld ist nicht verfügbar oder kann hier nicht geändert werden.',
        invalid: 'Bitte prüfe Deine Angaben.',
    },
}
